var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIncognito = function SvgIncognito(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5.937 8.999.722-4.331a2.002 2.002 0 0 1 1.974-1.672h6.613c.979 0 1.813.708 1.974 1.672l.723 4.33m-7.718 9.005a3.001 3.001 0 1 1-6.002 0 3.001 3.001 0 0 1 6.002 0Zm0 0c.948-1.144 2.483-1.144 3.43 0m0 0a3.001 3.001 0 1 0 6.003 0 3.001 3.001 0 0 0-6.002 0ZM2.997 13c4.973-2.668 13.035-2.668 18.008 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIncognito);
export default ForwardRef;